import { render, staticRenderFns } from "./JjCard.vue?vue&type=template&id=2b01e96c&scoped=true"
import script from "./JjCard.vue?vue&type=script&lang=js"
export * from "./JjCard.vue?vue&type=script&lang=js"
import style0 from "./JjCard.vue?vue&type=style&index=0&id=2b01e96c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b01e96c",
  null
  
)

export default component.exports